<!--
 * @Author: your name
 * @Date: 2022-01-09 15:45:50
 * @LastEditTime: 2022-09-04 22:38:58
 * @LastEditors: zhangdasen zhangdasen@conew.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /smash_web/src/views/installIpa.vue
-->
<template>

<div class="body" ontouchstart="">
  <van-overlay :show="show" @click="show = false">
    <div class="wrapper2" @click.stop>
      <label style="color:azure;font-size:19px;font-weight:bold"> 请点击右上角按钮，在弹出的菜单中，选择 在safari(默认浏览器)中打开! </label>
    </div>
  </van-overlay>

  <section v-if="pageStatus === 'error'" class="error-page" role="alert">
    <div class="error-card">
      <span class="error-code">{{pageErrorCode}}</span>
      <h1>{{pageErrorTitle}}</h1>
      <p>{{pageErrorMessage}}</p>
      <button type="button" @click="reloadPage">重新加载</button>
    </div>
  </section>

  <template v-else>
  <div class="center-container-ipa" v-if="isMoreIpa">
<el-form>
  <div class="container_install">
    <template>
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom:20px">
        <el-table-column
          prop="name"
          label="名字">
        </el-table-column>
        <el-table-column
          prop="version"
          label="版本">
        </el-table-column>
        <el-table-column
        prop="link"
        label="生成二维码">
        <template slot-scope="scope">
          <el-button aria-label="生成二维码" @click="copyLink(scope.row.fileId)" type="warning" icon="el-icon-document-copy" circle></el-button>
         </template>
        </el-table-column>
        <el-table-column
        prop="download"
        label="安装">
        <template slot-scope="scope">
          <el-button aria-label="安装" @click="instalIPA(scope.row.fileId)" type="success" icon="el-icon-download" circle></el-button>
         </template>
        </el-table-column>
        
      </el-table>
    </template>
  </div>
</el-form>
</div>
    <div class="mobile-wrap center">
      <main aria-label="App 安装详情">
        <div class="appItem">
          <div class="left">
            <img
              :src="appLogoSrc"
              :alt="appLogoAlt"
              width="120"
              height="120"
              fetchpriority="high"
              @error="handleAppLogoError"
            />
          </div>
          <div id="qrcode" class="qrcode" ref="qrcodeContainer"></div> 
          <div class="right">
            <strong>{{currentApp.name}}<span>1+</span></strong>
            <p>第 1 名</p>
            <div class="installBox">
              <button class="down" type="button" @click="installFree">安装</button>
              <button class="down2" type="button" v-if="!isMoreIpa" @click="gesQrCode">二维码</button>
            </div>
          </div>
          <div class="appTip">
            <div class="score">
              <div class="star">4.9 <var></var></div>
              <p>19k 个评分</p>
            </div>
            <div class="centerBox"><i>#</i>4</div>
            <div class="age">
              <b>18+</b>
              <p>年龄</p>
            </div>
          </div>
        </div>
        <div class="comment">
          <strong class="publicTitle">评分及评论</strong>
          <div class="left">
            <b>4.9</b>
            <p>满分 5 分</p>
          </div>
          <div class="right">
            <div class="star_row">
              <span class="s1"><i></i></span>
              <div class="lineBox"><var class="v1"></var></div>
            </div>
            <div class="star_row">
              <span class="s2"><i></i></span>
              <div class="lineBox"><var class="v2"></var></div>
            </div>
            <div class="star_row">
              <span class="s3"><i></i></span>
              <div class="lineBox"><var class="v3"></var></div>
            </div>
            <div class="star_row">
              <span class="s4"><i></i></span>
              <div class="lineBox"><var class="v4"></var></div>
            </div>
            <div class="star_row">
              <span class="s5"><i></i></span>
              <div class="lineBox"><var class="v5"></var></div>
            </div>
            <p>19k 个评分</p>
          </div>
        </div>
        <div class="newFunction">
          <strong class="publicTitle">新功能</strong>
          <p>{{currentApp.version}}</p>
        </div>
        <div class="appInfo">
          <strong class="publicTitle">信息</strong>
          <div class="box">
            <ul>
              <li>
                <span>大小</span>
                <p>40 MB</p>
              </li>
              <li>
                <span>兼容性</span>
                <p>
                  Android系统 或 iOS 8.0 或更高版本。与 iPhone、iPad 和 iPod
                  touch 兼容。
                </p>
              </li>
              <li>
                <span>语言</span>
                <p>英语,简体中文</p>
              </li>
              <li>
                <span>年龄分级</span>
                <p>限18岁以上</p>
              </li>
              <li>
                <span>Copyright</span>
                <p>© 2018 MobiFun Games Inc</p>
              </li>
              <li>
                <span>价格</span>
                <p>收费</p>
              </li>
              <li>
                <span>隐私政策</span>
                <p>查看</p>
              </li>
            </ul>
          </div>
        </div>
      </main>


      <div class="footer">
        <p class="p2">
          仅供测试，禁止用于非法用途。
        </p>
      </div>
      <div class="pup">
        <div class="guide">
          <i class="colse"></i>
          <div class="pics">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="pic">
                    <img src="../assets/0df0c_0_600_411.jpg" alt="" />
                  </div>
                  <div class="text">
                    安装引导<br />第一步 允许打开配置描述文件
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="pic">
                    <img src="../assets/9179e_3_600_411.jpg" alt="" />
                  </div>
                  <div class="text">
                    安装引导<br />第二步 点击右上角安装按钮
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="pic">
                    <img src="../assets/d3c74_2_600_411.jpg" alt="" />
                  </div>
                  <div class="text">安装引导<br />第三步 输入开机解锁密码</div>
                </div>
                <div class="swiper-slide">
                  <div class="pic">
                    <img src="../assets/0665a_1_600_411.jpg" alt="" />
                  </div>
                  <div class="text">安装引导<br />第四步 点击下方安装按钮</div>
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
          <div class="smallTip"><a href="#">什么是描述文件？</a></div>
        </div>
      </div>
      <div class="pupPic">
        <img src="../assets/5cbc4_5_1242_2007.png" alt="" />
      </div>
    </div>
  </template>

  </div>
</template>


<style>
@import "../css/reset.css";
@import "../css/style.css";
@import "../css/swiper.min.css";
:root {
  font-size: 54px;
  color-scheme: light;
}

.body {
  min-height: 100vh;
  min-height: 100dvh;
  background: #f6f7f9;
  color: #111827;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", Arial, sans-serif;
  cursor: default;
}

.mobile-wrap {
  overflow-x: hidden;
  background: #fff;
}

main {
  padding: 0.42rem 5% 0.36rem;
}

.error-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 0.56rem 6%;
  background: #f6f7f9;
}

.error-card {
  width: 100%;
  max-width: 6.6rem;
  padding: 0.52rem 0.42rem;
  border: 1px solid #eceff3;
  border-radius: 0.18rem;
  background: #fff;
  box-shadow: 0 0.18rem 0.48rem rgba(15, 23, 42, 0.08);
  text-align: left;
}

.error-card .error-code {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 0.92rem;
  height: 0.42rem;
  border-radius: 999px;
  background: #fee2e2;
  color: #dc2626;
  font-size: 0.22rem;
  font-weight: 800;
  line-height: 1;
}

.error-card h1 {
  margin-top: 0.24rem;
  color: #111827;
  font-size: 0.42rem;
  font-weight: 800;
  line-height: 1.25;
}

.error-card p {
  margin-top: 0.16rem;
  color: #6b7280;
  font-size: 0.27rem;
  font-weight: 500;
  line-height: 1.55;
}

.error-card button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.72rem;
  height: 0.58rem;
  margin-top: 0.34rem;
  padding: 0 0.3rem;
  border: 0;
  border-radius: 999px;
  background: #087bff;
  color: #fff;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.26rem;
  font-weight: 700;
  line-height: 1;
  touch-action: manipulation;
  transition: background-color 180ms ease, box-shadow 180ms ease, opacity 180ms ease;
}

.error-card button:focus-visible {
  outline: 0.05rem solid rgba(37, 99, 235, 0.32);
  outline-offset: 0.04rem;
}

.error-card button:active {
  opacity: 0.82;
}

.container_install{
  flex-direction: row;
  padding: 10px;
}

.center-container-ipa {
  justify-content: center;
  align-items: center;
  display: flex;
  background-color: white;
}

.appItem {
  align-items: flex-start;
  padding-bottom: 0.38rem;
}

.appItem .left {
  flex: 0 0 1.55rem;
  width: 1.55rem;
  height: 1.55rem;
  -webkit-border-radius: 0.28rem;
          border-radius: 0.28rem;
  background: #f3f4f6;
  box-shadow: 0 0.08rem 0.2rem rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.appItem .left img {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 0;
  object-fit: cover;
}

.appItem .right {
  min-width: 0;
  width: -webkit-calc(100% - 1.86rem);
  width: calc(100% - 1.86rem);
}

.appItem .right strong {
  display: flex;
  align-items: center;
  gap: 0.1rem;
  min-width: 0;
  color: #111827;
  font-size: 0.37rem;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0;
  word-break: break-all;
  text-wrap: balance;
}

.appItem .right strong span {
  flex: 0 0 auto;
  margin-left: 0;
  border-color: #9ca3af;
  color: #6b7280;
  font-size: 0.2rem;
  font-weight: 700;
  line-height: 1;
}

.appItem .right p {
  margin-top: 0.06rem;
  color: #8b929d;
  font-size: 0.27rem;
  font-weight: 500;
}

.appItem .right .installBox {
  display: flex;
  gap: 0.28rem;
  justify-content: flex-start;
  padding-top: 0.28rem;
}

.appItem .right .installBox .down,
.appItem .right .installBox .down2 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.78rem;
  height: 0.58rem;
  padding: 0 0.3rem;
  border-radius: 999px;
  border: 0;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.27rem;
  font-weight: 700;
  line-height: 1;
  touch-action: manipulation;
  transition: background-color 180ms ease, box-shadow 180ms ease, opacity 180ms ease;
}

.appItem .right .installBox button:focus-visible {
  outline: 0.05rem solid rgba(37, 99, 235, 0.32);
  outline-offset: 0.04rem;
}

.appItem .right .installBox button:active {
  opacity: 0.82;
}

.appItem .right .installBox .down {
  background: #087bff;
  box-shadow: 0 0.08rem 0.16rem rgba(8, 123, 255, 0.2);
  color: #fff;
}

.appItem .right .installBox .down2 {
  background: #ff2b2b;
  box-shadow: 0 0.08rem 0.16rem rgba(255, 43, 43, 0.16);
  color: #fff;
}

.appItem .appTip {
  padding-top: 0.36rem;
}

.appItem .appTip > div {
  min-width: 0;
  flex: 1 1 0;
}

.appItem .appTip .score {
  text-align: left;
}

.appItem .appTip .score .star,
.appItem .appTip .centerBox,
.appItem .appTip .age b {
  color: #7b818c;
}

.appItem .appTip .score p,
.appItem .appTip .age p {
  color: #c9cdd4;
  font-weight: 500;
}

.comment,
.newFunction {
  border-color: #eceff3;
}

.comment {
  padding: 0.38rem 0;
}

.publicTitle {
  margin-bottom: 0.26rem;
  color: #111827;
  font-size: 0.38rem;
  font-weight: 800;
  letter-spacing: 0;
  text-wrap: balance;
}

.comment .left {
  padding-left: 0.1rem;
}

.comment .left b {
  color: #4b4d55;
  font-size: 1.08rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.comment .left p,
.comment .right p {
  color: #8b929d;
  font-weight: 600;
}

.comment .right .star_row .lineBox {
  height: 0.06rem;
  background-color: #eceff3;
}

.comment .right .star_row .lineBox var {
  background-color: #9297a1;
}

.newFunction,
.appInfo {
  padding: 0.38rem 0;
}

.newFunction p,
.appInfo .box ul li p {
  color: #1f2937;
  line-height: 1.5;
}

.appInfo .box ul li {
  align-items: flex-start;
  padding: 0.18rem 0;
  border-color: #eceff3;
}

.appInfo .box ul li span {
  color: #8b929d;
  font-weight: 600;
}

.footer {
  background: #f6f7f9;
  color: #9ca3af;
}

.footer p.p2 {
  text-indent: 0;
}

@media (max-width: 360px) {
  .appItem .left {
    flex-basis: 1.42rem;
    width: 1.42rem;
    height: 1.42rem;
  }

  .appItem .right {
    width: -webkit-calc(100% - 1.68rem);
    width: calc(100% - 1.68rem);
  }

  .appItem .right .installBox {
    gap: 0.16rem;
  }

  .appItem .right .installBox .down,
  .appItem .right .installBox .down2 {
    min-width: 1.52rem;
    padding: 0 0.22rem;
  }
}

.wechat-ios,
.wechat-android {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: none;
  overflow: hidden;
}
.wechat-ios img,
.wechat-android img {
  width: 100%;
  height: 100%;
}
.wechat-mask .mask-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
}
.wechat-mask .mask-pop {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 80%;
  max-width: 300px;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
}
.wechat-mask .copy-url-img {
  display: block;
  width: 100%;
}
.wechat-mask .copy-url {
  position: relative;
  margin: 20px 30px;
  height: 36px;
  line-height: 36px;
  background: #f1f6f9;
  border-radius: 18px;
  overflow: hidden;
}
.wechat-mask .copy-url input {
  padding-left: 20px;
  color: #9a9a99;
}
.wechat-mask .copy-url button {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0 15px;
  height: 36px;
  line-height: 36px;
  background: linear-gradient(
    90deg,
    rgba(34, 125, 249, 1),
    rgba(0, 203, 250, 1)
  );
  color: #fff;
  border-radius: 0 18px 18px 0;
}
.wechat-mask {
  z-index: 2;
  position: relative;
  display: block;
}

.down2 {
  background: #ff2b2b;
  color: #fff;
}
</style>



<script>

import {getSignedApp} from '@/api/member'
import {deleteCoin} from '@/api/install'

import { Dialog } from 'vant';
import {Message} from 'element-ui'
import QRCode from 'qrcodejs2'
import {Loading} from 'element-ui'

const DEFAULT_APP_ICON = 'https://is1-ssl.mzstatic.com/image/thumb/Purple122/v4/2c/15/d8/2c15d83f-49f8-712c-d77f-f7a01f8e6c04/AppIcon-0-1x_U007emarketing-0-0-0-7-0-0-P3-85-220-0.png/512x512bb.jpg'

export default {
  data() {
    return {
      defaultAppIcon: DEFAULT_APP_ICON,
      logoLoadFailed: false,
      udid: '点击按钮，立即安装APP',
      password: '',
       dialogVisible: false,
       fits: ['fill'],
       options: [],
       value: '',
       loading :null,
       loading_edit: true,
       userData : null,
       code:"",
       ipaUrl:"",
       installURL:"",
       fileId:"",
       ids:[],
       idsData:[],
       tableData: [],
       show:false,
       pageStatus: 'loading',
       pageErrorCode: 'ERROR',
       pageErrorTitle: '应用加载失败',
       pageErrorMessage: '请检查链接是否正确，或稍后再试。',
       isMoreIpa:false
    }
  },

  computed: {
    currentApp() {
      return this.tableData[0] || {
        name: '',
        version: '',
        fileId: '',
        logo: ''
      }
    },

    appLogoSrc() {
      if (this.logoLoadFailed || !this.currentApp.logo) {
        return this.defaultAppIcon
      }
      return this.currentApp.logo
    },

    appLogoAlt() {
      if (this.currentApp.name) {
        return this.currentApp.name + ' 图标'
      }
      return 'App 图标'
    }
  },

  methods: {
     getIpaLogoSrc(ipaLogo){
        if (typeof ipaLogo !== 'string') {
          return ''
        }

        var logo = ipaLogo.trim()
        if (logo === '') {
          return ''
        }

        if (/^data:image\//i.test(logo)) {
          return logo
        }

        var base64Logo = logo.replace(/\s/g, '')
        return 'data:' + this.getIpaLogoMimeType(base64Logo) + ';base64,' + base64Logo
    },

    getIpaLogoMimeType(base64Logo) {
      if (base64Logo.indexOf('/9j/') === 0) {
        return 'image/jpeg'
      }
      if (base64Logo.indexOf('R0lGOD') === 0) {
        return 'image/gif'
      }
      if (base64Logo.indexOf('UklGR') === 0) {
        return 'image/webp'
      }
      if (base64Logo.indexOf('PHN2Zy') === 0) {
        return 'image/svg+xml'
      }
      return 'image/png'
    },

    handleAppLogoError(){
      this.logoLoadFailed = true
    },

    getShareUrl(fileId){
      return window.location.origin + '?id=' + encodeURIComponent(fileId)
    },

    setPageError(error){
      this.pageStatus = 'error'
      this.isMoreIpa = false
      this.tableData = []
      this.pageErrorCode = error.code || 'ERROR'
      this.pageErrorTitle = error.title || '应用加载失败'
      this.pageErrorMessage = error.message || '请检查链接是否正确，或稍后再试。'
    },

    clearPageError(){
      this.pageStatus = 'loading'
      this.pageErrorCode = 'ERROR'
      this.pageErrorTitle = '应用加载失败'
      this.pageErrorMessage = '请检查链接是否正确，或稍后再试。'
    },

    getApiError(error){
      var status = error && error.response && error.response.status
      var responseData = error && error.response && error.response.data
      var apiError = responseData && responseData.error ? responseData.error : responseData
      var code = status || (apiError && apiError.code)
      var name = apiError && apiError.name
      var message = apiError && (apiError.message || apiError.messae)

      if (code === 404 || name === 'NotFound') {
        return {
          code: '404',
          title: '应用不存在',
          message: message || '记录未找到，请检查链接或重新生成二维码。'
        }
      }

      return {
        code: code ? String(code) : 'ERROR',
        title: '应用加载失败',
        message: message || (error && error.message) || '请检查链接是否正确，或稍后再试。'
      }
    },

    getDataError(data){
      if (!data || !data.error) {
        return null
      }

      var code = data.error.code
      var name = data.error.name
      var message = data.error.message || data.error.messae
      if (code === 404 || name === 'NotFound') {
        return {
          code: '404',
          title: '应用不存在',
          message: message || '记录未找到，请检查链接或重新生成二维码。'
        }
      }

      return {
        code: code ? String(code) : 'ERROR',
        title: '应用加载失败',
        message: message || '请检查链接是否正确，或稍后再试。'
      }
    },

    reloadPage(){
      window.location.reload()
    },

     checkIsWeChat(){
        if (navigator.userAgent.indexOf("MicroMessenger") !== -1) {
            alert("请点击右上角按钮，在弹出的菜单中，选择 在safari(默认浏览器)中打开!");
            return true;
        }else{
            return false;
        }
    },

    installFree(){
      if (this.currentApp.fileId) {
        this.instalIPA(this.currentApp.fileId);
      }
    },


    gesQrCode(){
      if (this.currentApp.fileId) {
        this.copyLink(this.currentApp.fileId);
      }
    },

     creatQrCode() {
      document.getElementById("qrcode").innerHTML = "";
      new QRCode(this.$refs.qrcodeContainer, {  
          text: this.ipaUrl,  
          width: 200,  
          height: 200,
          colorDark: '#000000',  
          colorLight: '#ffffff',  
          correctLevel: QRCode.CorrectLevel.H  
      });
    },

    async requestIPA(id){
      this.clearPageError()

      if (!id) {
        this.setPageError({
          code: 'ERROR',
          title: '缺少应用 ID',
          message: '当前链接没有包含应用 ID，请检查链接是否完整。'
        })
        return
      }

      this.ids = id.split(',').map(function(item) {
        return item.trim()
      }).filter(function(item) {
        return item !== ''
      });

      if (this.ids.length === 0) {
        this.setPageError({
          code: 'ERROR',
          title: '缺少应用 ID',
          message: '当前链接没有包含有效的应用 ID，请检查链接是否完整。'
        })
        return
      }

      this.tableData = [];
      this.logoLoadFailed = false;

      this.isMoreIpa = this.ids.length > 1 ? true : false;
      try {
        for (var i=0;i<this.ids.length; i++){

          var requestId = this.ids[i];
          var data = await getSignedApp(requestId, false, { silentError: true });
          if (!data) {
            throw new Error('接口返回为空，请稍后再试。')
          }
          var dataError = this.getDataError(data);
          if (dataError) {
            this.setPageError(dataError)
            return
          }

          var name = data.ipa_name;
          var version = data.ipa_version;
          var fileId = data.id;
          var logo = this.getIpaLogoSrc(data.ipa_logo);

          var newDic = {}
          newDic["name"]  = name;
          newDic["version"]  = version;
          newDic["fileId"]  = fileId;
          newDic["logo"]  = logo;
          this.tableData.push(newDic);
        }
        this.pageStatus = 'ready'
      } catch (error) {
        this.setPageError(this.getApiError(error))
      }
    },

    // 扣费接口
    async deleteCoinMethod(fileId,installURL) {
      var res = await deleteCoin(fileId);
      if (res != null && res != undefined) {
        localStorage.setItem(installURL, "1");
      }
    },

    getQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = decodeURI(window.location.search.substr(1)).match(reg);
        if (r != null)return unescape(r[2]);
        return null;
    },


    async copyLink(fileId){
      this.ipaUrl = this.getShareUrl(fileId);
      this.creatQrCode();
      this.$copyText(this.ipaUrl ).then(
      () => {
      Message({
        message:"链接已复制！",
            type: 'success',
            duration: 1 * 1000,
            offset:document.body.clientHeight * 0.5 - 100
          })
      },
      () => {
      }
    );

    },

    installApp(fileId,installURL){
      window.location.href = installURL;
      var saveState = window.localStorage.getItem(installURL);
      if (saveState != "1"){
        this.deleteCoinMethod(fileId,installURL);
        console.log("扣费成功");
      }else{
        console.log("没扣费");
      }
    },

   async instalIPA(fileId){
    try {
      var data = await getSignedApp(fileId, true);
      var dataError = this.getDataError(data);
      if (dataError) {
        Message({
          message: dataError.message,
          type: 'error',
          duration: 2 * 1000
        })
        return
      }
      if (!data) {
        throw new Error('接口返回为空，请稍后再试。')
      }

      var plistUrl = data.plist_url_v2;
      if (plistUrl == undefined){
        plistUrl = data.plist_url;
      }
      if (plistUrl != undefined){
        Dialog.confirm({
          title: '提示',
          message:
            '是否确认进行安装？',
        }).then(() => {
         var options = {
            body: true,
            lock: true,
            text: '正在读取中......',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.6)'
          }

          var installURL = "itms-services://?action=download-manifest&url=" + plistUrl;
          let loadingInstance = Loading.service(options);
          var tThis = this;
          setTimeout(function() {
            loadingInstance.close();
            tThis.installApp(fileId,installURL);
          }, 2000);
        })
      }
    } catch (error) {
      Message({
        message: this.getApiError(error).message,
        type: 'error',
        duration: 2 * 1000
      })
    }
    }
  },

  mounted() {
    var appID = this.getQueryString("id");
    this.requestIPA(appID);

    this.show =  this.checkIsWeChat();
    
  },
}
</script>
